import { Link } from 'react-router-dom';
import styles from '../../pages/DashboardPage.module.css';

type Props = {
  label: string;
  value: string | number;
  warn?: boolean;
  href?: string;
  title?: string;
};

export function DashboardKpiCard({ label, value, warn, href, title }: Props) {
  const inner = (
    <>
      <div className={styles.kpiValue}>{value}</div>
      <div className={styles.kpiLabel}>{label}</div>
    </>
  );

  const className = `${styles.card} ${warn ? styles.cardWarn : ''} ${href ? styles.cardLink : ''}`;

  if (href) {
    return (
      <Link to={href} className={className} title={title}>
        {inner}
      </Link>
    );
  }

  return (
    <div className={className} title={title}>
      {inner}
    </div>
  );
}
